export interface UserSlice {
  firstName: string;
  companyName: string;
  companyId: string;
  logoUrl: string;
  feedbackUrl?: string;
  setFirstName: (newFirstName: string) => void;
  chatQuestions?: string[];
  chatGreeting?: string;
  promptOptions?: {
    roles: string[];
    industry_ids?: [number, string][];
    industries: [number, string][];
    region_ids?: [number, string][];
    regions: [number, string][];
    subordinate_regions?: [number, string][];
  };
  promptProfile?: boolean;
}
